<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        enctype="multipart/form-data"
        :data-url="
          selectedUrl
            ? `/accreditationReview/extension_time/request/process602/${inputs.id}`
            : `/accreditationReview/extension_time/request/process602`
        "
      >
        <div class="row text-center">
          <div class="col-12">
            <div class="form-group">
              <div v-if="inputs.status == 40">
                <legend>
                  <label class="text-primary">Solicitud de  extensión de tiempo OEC</label>
                </legend>
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab('extension_time601')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </div>
              <div v-if="inputs.status == 178">
                <legend>
                  <label class="text-primary">Solicitud de  extensión de tiempo lider</label>
                </legend>
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab('extension_time603')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row text-center">
          <div class="col-md-12">
            <div class="form-group">
              <label>¿Aprueba la solicitud?</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.extension_time602"
                :list="confirm"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="!inputs.extension_time602">
          <div class="col-12">
            <div class="form-group">
              <label>Observaciones</label>
              <app-input
                type="textarea"
                v-model="inputs.observations_302"
                placeholder="Ingrese las observaciones"
                :required="true"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="inputs.extension_time602">
          <div class="col-12">
            <div class="form-group">
              <label>Ingresar el tiempo en días</label>
              <app-input
                  type="number"
                  v-model="inputs.time_extra"
                  placeholder="Ingrese el número de días"
                  :required="true"
              />
            </div>
          </div>
        </div>



      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="submit" class="btn btn-primary" @click.prevent="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      file_evaluation_historical: [],
      sampling_plan_file_historical: [],
      modalId: "modal-add-edit",
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },

    observations_303() {
      let tmp = [];
      if (this.inputs.observations_evaluation_team) {
        tmp = this.inputs.observations_evaluation_team.filter(
          (item) => item.status.code == "303"
        );
      }
      return tmp;
    },

    observations_305() {
      let tmp = [];
      if (this.inputs.observations_evaluation_team) {
        tmp = this.inputs.observations_evaluation_team.filter(
          (item) => item.status.code == "305"
        );
      }
      return tmp;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    } else {
      this.inputs.requirement =
        this.$store.state.evaluatorReview.evalTest.accreditation_applications.accreditation_activity.rule_name;
    }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    afterSuccessFromGetEditData({ data: data }) {
      this.preloader = false;
      this.inputs = data;
      if (data.file_evaluation_historical.length > 0) {
        this.file_evaluation_historical = data.file_evaluation_historical;
      }
      if (data.sampling_plan_file_historical.length > 0) {
        this.sampling_plan_file_historical = data.sampling_plan_file_historical;
        this.sampling_plan_file_historical.pop();
      }
    },

    openTab(fileName) {
      const w = window.open(this.inputs[fileName].path, "_blank");
      w.focus();
    },

    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD HH:mm") : null;
    },
  },
};
</script>
